import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { catchError } from 'rxjs/operators';
import { DynamicField, FormDataDto, ServiceSelectionDto } from 'src/app/services/dtos';
import { HttpSubmissionService } from 'src/app/services/http-submission.service';
import { ToastService } from 'src/app/services/toast.service';

class DynamicFieldWithImage {
	field: DynamicField;
	image: any;
}

@Component({
  selector: 'app-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.scss']
})
export class SummaryComponent {

	textFields: DynamicField[];
	imageFields: DynamicFieldWithImage[];
	qrData: string;
	@Input() serviceSelection: ServiceSelectionDto;
	@Output() onBack = new EventEmitter();
    constructor(private toast: ToastService, private httpSubmissionService: HttpSubmissionService, private spinner: NgxSpinnerService) { }

	@Input()
	set formData(input: FormDataDto) {

		this.spinner.show();
		this.httpSubmissionService.flush(this.serviceSelection)
		.pipe(
			catchError(error => {
				this.spinner.hide();
				console.log('Error', error);
				
				this.toast.show('Failed saving self registration: ' + error.error.message);
				throw error;
			})
		)
		.subscribe(
			data => {
				console.log("Qr Data: " + data);
				this.qrData = data.qrData;
				this.textFields = this.getFieldsByCardType(input, 'text');
				this.textFields.forEach(item => {
					console.log('Field [' + item.field +'] Inputfield: ', item.inputField);
					if ( item.inputField === 'date' ) {
						console.log('Date field [' + item.field +'] value =', item.formControl.value);
						if (item.formControl.value instanceof Date) {
							item.value = item.formControl.value.getDate() + "/" + (item.formControl.value.getMonth() + 1) + "/" + item.formControl.value.getFullYear();
							console.log('Out date: ', item.value);
						} else if (typeof item.formControl.value === 'string') {
							var d = new Date(item.formControl.value);
							item.value = d.getDate() + "/" + (d.getMonth() + 1) + "/" + d.getFullYear();
							console.log('Out date: ', item.value);
						} else {
							try {
								var d = new Date();
								d.setFullYear(item.formControl.value.year);
								d.setUTCMonth(item.formControl.value.month - 1);
								d.setDate(item.formControl.value.day);
								item.value = d.getDate() + "/" + (d.getMonth() + 1) + "/" + d.getFullYear();
								console.log('Out date: ', item.value);
							} catch (e) {
								console.log("Failed to extract date from NgbDate");
								console.log(e);
							}
						}
					} else {
						item.value = item.formControl.value;
					}
				});

				this.imageFields = this.getFieldsByCardType(input, 'image')
					.filter(item => item.formControl?.value)
					.map(item => {
						let out = new DynamicFieldWithImage();
						out.field = item;
						
						if ( out.field.inputField !== 'display_contract' ) {
							var reader = new FileReader();
							reader.onload = e => out.image = e.target.result;
							reader.readAsDataURL(item.formControl.value);
						}
						
						return out;
					});
				this.spinner.hide();
			}
		);
	}

	private getFieldsByCardType(formData: FormDataDto, type: string): DynamicField[] {
		const fields = new Array();
		formData.data.cards
			.filter(item => item.type === type)
			.forEach(item => {
				fields.push(...item.fields);
			});
		return fields;
	}

	previousStep() {
		this.onBack.emit();
	}

	getQrData() {
		return ''+this.serviceSelection.axonId
	}
}
